import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/kardex/trazabilidad',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['079'],
  cita: 'Areas/ReportesBI/Controllers/KardexController.cs',
} satisfies RutaProd;
